import CalssqBanner from "./img-classq-banner.jpg";
import phoneScreensWide from "./vid-hero-wide.mp4"
import phoneScreensVertical from "./vid-hero-vertical.mp4"


function Hero() {
    return (
        <div className="w-full flex flex-col lg:-translate-y-10" dir="ltr">
            <div className="flex flex-col mb-8 lg:items-end space-y-2 lg:flex-row lg:space-y-0 lg:justify-between">
                <h1>ClassQ</h1>
                <p className="text-3xl font-bold">مصممة خصيصا <span className='text-secondary'>للمؤطرين</span></p>
                <p className="text-3xl font-bold">أكثر من <span className='text-secondary'>500+</span> مستخدم في الجزائر</p>
            </div>

            <div className="rounded-3xl overflow-hidden h-[68vh] 
                            lg:h-[72vh]">
                <video src={phoneScreensWide} autoPlay loop muted className="hero-video w-full hidden h-fit lg:block" />
                <video src={phoneScreensVertical} autoPlay loop muted className="hero-video w-full h-fit block lg:hidden" />
            </div>
        </div>
    );
}

export default Hero;